import React, { useState, useEffect } from 'react'
import { setConfig } from 'react-hot-loader'
import 'styles/main.scss'
import { graphql } from 'gatsby'
import ContentBlock from 'components/ContentBlock'
import SuccessStories from 'components/SuccessStories'
import GetStarted from 'components/GetStarted'
import SearchByBlock from 'components/SearchByBlock'
import Modal from 'components/Modal'
import ModalProvider from 'providers/Modal'
import Layout from 'components/layouts/home'
import HomeBanner from 'components/HomeBanner'
import Panel from 'components/common/Panel'
import Register from 'components/Register'
import Login from 'components/Login'
import FaqSection from 'components/FaqSection'
import { domainName } from 'utils/parseDomain'
import MeetIntroduction from 'components/MeetIntroduction'
import { getCookie } from 'utils/cookie'
import GoogleOneTap from 'components/GoogleOneTap'

setConfig({ pureSFC: true })

const Panels = props => (
  <>
    <Panel id="login" isActive="login">
      <Login />
    </Panel>
    <Panel id="register" isActive="register">
      <Register {...props} />
    </Panel>
  </>
)

const prepareStoriesCriteria = props => ({
  storiesType: props.matrimonial_type,
  storiesDb:
    props.matrimonial_type === 'caste'
      ? { religion: props.matrimonialDb, caste: props.matrimonialDb }
      : props.matrimonialDb,
})

const IndexPage = props => {
  const [state, setState] = useState({
    revampViewBucket: '',
  })
  const [GsuBucket, setGsuBucket] = useState('A')

  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    setState({ revampViewBucket })
  }, [])

  useEffect(() => {
    const bucket = getCookie('GsuExp')
    setGsuBucket(bucket)
  }, [getCookie, setGsuBucket])

  const shouldShowGoogleOneTap = () =>
    ['shaadi.com'].includes(domainName) && GsuBucket === 'B'

  return (
    <Layout {...props}>
      <ModalProvider>
        {shouldShowGoogleOneTap() && <GoogleOneTap />}
        <HomeBanner {...props} />
        {!['H'].includes(state.revampViewBucket) && (
          <>
            <ContentBlock
              strDisplayWord={props.data.airtable.data.matrimonialDb}
            />
            <MeetIntroduction {...props} />
            {!['parsishaadi.com'].includes(domainName) && (
              <SuccessStories
                storiesTitle={props.data.airtable.data.success_story_heading}
                storiesCriteria={prepareStoriesCriteria(
                  props.data.airtable.data
                )}
              />
            )}
            <GetStarted />
            <SearchByBlock
              searchByData={props.data.airtable.data.SearchByDomainLinks}
            />
            {['bengalishaadi.com'].includes(domainName) && <FaqSection />}
          </>
        )}
        <Modal>
          <Panels {...props} />
        </Modal>
      </ModalProvider>
    </Layout>
  )
}

export const query = graphql`
  query homePageData($domain: String!) {
    airtable(table: { eq: "Homepages" }, data: { filename: { eq: $domain } }) {
      data {
        title
        metatags
        description
        leading_copy_line1
        success_story_heading
        matrimonialDb
        matrimonial_type
        SearchByDomainLinks {
          data {
            id
            anchortag
            link
            type
            subtype
            orderby
          }
        }
        footer_text
      }
      fields {
        webCreatives
        mobileCreatives
        metaImage
        domainLogo
        logoDimension
        showSixMillion
        androidAppStore
        iphoneAppStore
        domainReligion
        domainLanguage
        domainCountry
        topNavRightColor
      }
    }
  }
`
export default IndexPage
